import {
    getSummary, saveOrganizationData, importSettingData, getDNSSetting
} from './site-data';

import { UPLOAD_FILE_INIT, UPLOAD_FILE_FAIL, UPLOAD_FILE_SUCCESS } from '../../actions/index';

// Site
export const WAIT_INIT_SITE = "WAIT_INIT_SITE";
export const SELECT_SITE = "SELECT_SITE";
export const RE_SELECT_SITE = "RE_SELECT_SITE";
export const SELECT_SITE_MODE = "SELECT_SITE_MODE";
export const GET_SITE_SUMMARY = "GET_SITE_SUMMARY";
export const GET_SITE_SUMMARY_SUCCESS = "GET_SITE_SUMMARY_SUCCESS";
export const GET_SITE_SUMMARY_FAIL = "GET_SITE_SUMMARY_FAIL";
// Site Form
export const SAVE_ORGANIZATION_DATA = "SAVE_ORGANIZATION_DATA";
export const SAVE_ORGANIZATION_DATA_SUCCESS = "SAVE_ORGANIZATION_DATA_SUCCESS";
export const SAVE_ORGANIZATION_DATA_FAIL = "SAVE_ORGANIZATION_DATA_FAIL";

export const GET_DNS_SETTING = "GET_DNS_SETTING";
export const GET_DNS_SETTING_SUCCESS = "GET_DNS_SETTING_SUCCESS";
export const GET_DNS_SETTING_FAIL = "GET_DNS_SETTING_FAIL";

export const loadSiteSummary = (token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getSummary(resolve, reject, token);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            let siteOptions = [];
            if (data.siteSummaryList && data.siteSummaryList.length > 0) {
                data.siteSummaryList.forEach(item => {
                    const objSite = {
                        key: item.id,
                        value: item.name
                    }
                    siteOptions.push(objSite);
                });
            }

            const siteParams = {
                siteSummaryList: data.siteSummaryList,
                siteOptions: siteOptions,
                selectSite: data.selectSite,  
                selectSiteName: data.selectSiteName,
                initialSetup: data.initialSetup            
            };

            window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.SITE, JSON.stringify(siteParams));

            dispatch({
                type: GET_SITE_SUMMARY_SUCCESS,
                params: siteParams
            });
        } else {
            dispatch({
                type: GET_SITE_SUMMARY_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SITE_SUMMARY_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SITE_SUMMARY        
    });
}

export const reSiteBySession = () => (dispatch) => {
    const siteParams = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.SITE));

    dispatch({
        type: RE_SELECT_SITE,
        params: siteParams
    });
}

export const doSelectSiteMode = (selectMode) => (dispatch) => {
    dispatch({
        type: SELECT_SITE_MODE,
        params: {
            siteMode: selectMode
        }
    });
}

export const doSelectSite = (selectSite, reqUUID) => (dispatch) => {
    let siteParams = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.SITE));
    if (!siteParams) {
        siteParams = {};
    }
    siteParams.selectSite = selectSite;
    window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.SITE, JSON.stringify(siteParams));

    dispatch({
        type: SELECT_SITE,
        params: {
            selectSite: selectSite,
            reqUUID: reqUUID
        }
    });
}

export const doSaveOrganizationData = (saveData, modalMessage, authToken, siteOptions) => (dispatch) => {    
    let doPost = new Promise((resolve, reject) => {
        saveOrganizationData(resolve, reject, saveData, modalMessage, authToken)
    });

    doPost
        .then((data) => {
            if ('success' === data.status) {
                let options = [];
                if (siteOptions) {
                    siteOptions.forEach(item => {
                        options.push({
                            key: item.key,
                            value: saveData.id === item.key ? saveData.name : item.value
                        });
                    });
                }

                dispatch({
                    type: SAVE_ORGANIZATION_DATA_SUCCESS,
                    params: {
                        siteOptions: options
                    }
                });
            } else {
                dispatch({
                    type: SAVE_ORGANIZATION_DATA_FAIL,
                    params: {
                        errMsg: data.status
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: SAVE_ORGANIZATION_DATA_FAIL,
                params: {
                    errMsg: err
                }
            });
        });


    dispatch({
        type: SAVE_ORGANIZATION_DATA
    });
}

export const doImportSetting = (formData, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        importSettingData(resolve, reject, token, formData)
    });
    doPost
    .then((res) => {        
        let dispatchType = '';
        if (res.message === 'success') {
            dispatchType = UPLOAD_FILE_SUCCESS;
        } else {
            dispatchType = UPLOAD_FILE_FAIL;
        }
        dispatch({
            type: dispatchType,
            params: {
                uploadInfo: res
            }
        });      
    }).catch((err) => {
        dispatch({
            type: UPLOAD_FILE_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type : UPLOAD_FILE_INIT
    });
}




export const loadDNSSetting = (token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getDNSSetting(resolve, reject, token);
    });
    doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_DNS_SETTING_SUCCESS,
                    params: data.dnsList
                });
            } else {
                dispatch({
                    type: GET_DNS_SETTING_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
        dispatch({
            type: GET_DNS_SETTING_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_DNS_SETTING
    });
}
